import { render, staticRenderFns } from "./BaseContentCategory.vue?vue&type=template&id=b0d56298&"
import script from "./BaseContentCategory.vue?vue&type=script&lang=ts&"
export * from "./BaseContentCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports